import * as React from "react";

import * as dates from "../../../reducers/changeTimePeriod";

import { IDayCellSlot_Month } from "../../../classes/dayCell_Month";

import { EventTooltip } from "../Common/EventTooltip";

import { MonthDayCellEventAnchor } from "./MonthDayCellEventAnchor";

import { ILinkParams } from "../../../classes/linkParams";

// import * as redirect from "../../Common/redirectLink";

import { displayEventDetails, redirectToEventDetails } from "../../Common/buttonEvents";

export interface IMonthDayCellEvent {
    allDayText: string;
    dayCellSlot: IDayCellSlot_Month;
    eventText: string;
    monthStart: Date;
    date: Date;
    userDateFormat: string;
    portalId: number;
    portletInstanceId: number;
    pageId: number;
    objectId: number;
    onText: string;
    contextId: number;
    parentId: number;
    viewMode: string;
    selectedDate: Date;
    toText: string;
    todaysDate: Date;
    onSetEventId: (eventId: number) => any;
    onSetEventScreenMode: (eventScreenMode: string) => any;
    onSetiCalStartDate: (iCalStartDate: Date) => any;
    onSetDisplayedEventLocalStartDate: (localStartDate: Date) => any;
    onSetDisplayedEventLocalEndDate: (localEndDate: Date) => any;
    onStartAjaxCall: (event: any) => any;
}

export const MonthDayCellEvent = (props: IMonthDayCellEvent) => {

    const event = props.dayCellSlot.event;
    const eventID = event.eventID;
    const iCalStartDate = event.localStartDate;
    const displayedEventLocalStartDate = event.localStartDate;
    const displayedEventLocalEndDate = event.localEndDate;

    // If event extends for more than one day, add 'CAL-V-MV-multi-N' class (where N = number of days to extend).
    let itemClass = "CAL-EV-Item";
    if (props.dayCellSlot.maxExtensionWithinWeek > 0) {
        itemClass += " CAL-V-MV-multi CAL-V-MV-multi-" + (props.dayCellSlot.maxExtensionWithinWeek + 1);
    }

    const onSetEventId = () => {
        props.onSetEventId(eventID);
    };

    const onSetEventScreenModeToView = () => {
        props.onSetEventScreenMode("VIEW");
    };

    const onSetiCalStartDate = () => {
        props.onSetiCalStartDate(iCalStartDate);
    };

    const onSetDisplayedEventLocalStartDate = () => {
        props.onSetDisplayedEventLocalStartDate(displayedEventLocalStartDate);
    };

    const onSetDisplayedEventLocalEndDate = () => {
        props.onSetDisplayedEventLocalEndDate(displayedEventLocalEndDate);
    };

    return (
        // <li className={itemClass} onClick={(e) => redirectToEventDetails(e, eventID, eventReference, contextId, selectedDate, todaysDate, pageId, parentId, portalId, portletInstanceId, viewMode, onStartAjaxCall)} >
        <li className={itemClass} onClick={(e) => displayEventDetails(e, eventID, onSetEventId, onSetEventScreenModeToView, onSetiCalStartDate, onSetDisplayedEventLocalStartDate, onSetDisplayedEventLocalEndDate)} >
            <MonthDayCellEventAnchor
                allDayText={props.allDayText}
                onText={props.onText}
                toText={props.toText}
                date={props.date}
                event={event}
                eventText={props.eventText}
                monthStart={props.monthStart}
                userDateFormat={props.userDateFormat
            }
            />
            <EventTooltip allDayText={props.allDayText} event={event} />
        </li>
    );
};
